require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-u-s-treasury-calls-for-critical-reforms-to-world-bank.json") })
        }
      }, "path---en-us-update-u-s-treasury-calls-for-critical-reforms-to-world-bank");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-u-s-treasury-calls-for-critical-reforms-to-world-bank!./.cache/json/en-us-update-u-s-treasury-calls-for-critical-reforms-to-world-bank.json
// module id = 814
// module chunks = 231608221292675